const config = require(process.env.VUE_APP_CONFIG_FILE!).default;

export default {
  isProduction: process.env.NODE_ENV === 'production',
  showDevTools: false,
  routerMode: 'history',
  staticOTP: true,
  ...config,
};
